

















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Category extends Vue {
    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getCategories(this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的题库, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delCategories({ data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 文章
    onArticle(id: string) {
        this.$router.push({ path: "/training/article", query: { categoryId: id } });
    }

    // 新增
    onAdd() {
        this.editForm = {
            name: "",
            sequence: 0
        }
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        this.editForm = {
            id: row.id,
            name: row.name,
            sequence: row.sequence
        }
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;
        
        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postCategory(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                });
        } else {
            // 编辑
            this.$apis.putCategory(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }
    }
}
